import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DirectorySearch } from '../components/DirectorySearch/DirectorySearch';
import { MusicianListing } from '../components/DirectoryListings/MusicianListing/MusicianListing';
import { useHeader } from '../components/Layout/MainLayout';
import { useMusicians } from '../api/queries';
import { theme } from 'antd';

function Musicians() {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const { data: musicians, isLoading, error } = useMusicians();
  const { searchQuery } = useHeader();
  const q = searchQuery.toLowerCase();

  const handleMusicianClick = (musicianId: string) => {
    navigate(`/musicians/${musicianId}`);
  };

  return (
    <div className="directory-page">
      <div className="directory-page__tabs">
        <DirectorySearch activeTab="musicians" />
      </div>
      <div className="body-temp directory-page__list">
        {isLoading && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
            Loading musicians...
          </div>
        )}

        {error && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorError }}>
            Error loading musicians: {error.message}
          </div>
        )}

        {musicians && musicians.length > 0 && (() => {
          const filteredMusicians = q
            ? musicians.filter(musician =>
                `${musician.first_name} ${musician.last_name}`.toLowerCase().includes(q)
              )
            : musicians;
          return filteredMusicians.length > 0 ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}>
              {filteredMusicians.map((musician) => (
                <MusicianListing
                  key={musician.id}
                  name={`${musician.first_name} ${musician.last_name}`}
                  imageUrl={musician.photo_url}
                  onClick={() => handleMusicianClick(musician.id)}
                />
              ))}
            </div>
          ) : (
            <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
              No musicians found.
            </div>
          );
        })()}

        {musicians && musicians.length === 0 && !q && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
            No musicians found.
          </div>
        )}
      </div>
    </div>
  );
}

export default Musicians;
